import moment from "moment";
import { QRCodeSVG } from "qrcode.react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { currencyFormatter } from "utils/formatter";

function Verification({ details }) {
  const { t } = useTranslation();

  const handlePrint = () => {
    window.print();
  };

  return (
    <div>
      <div className="d-flex">
        {details.ofd && (
          <Button
            className="mt-1 ml-auto mr-1"
            color="light"
            onClick={() => {
              window.open(details.ofd.qrCodeUrl, "_blank");
            }}
          >
            <i className="iconsminds-qr-code" aria-hidden="true" /> Soliq QR
          </Button>
        )}
        <Button
          className="mt-1 ml-auto mr-1"
          color="light"
          onClick={handlePrint}
        >
          <i className="simple-icon-printer" aria-hidden="true" />{" "}
          {t("print")}
        </Button>
      </div>
      <div
        className={window.innerWidth < 480 ? "p-1" : "p-5"}
        id="printableContent"
      >
        <div className="col-12 d-block mt-2 text-center">
          <img
            src="/static/img/vertical.png"
            alt="logo"
            className="logo-white"
          />
        </div>
        <br />
        <h2
          style={
            window.innerWidth < 480
              ? { lineHeight: "0.7rem", color: "#ff6c1c" }
              : { color: "#ff6c1c" }
          }
        >
          {t("receipt.title")}
        </h2>
        <p
          className="text-left"
          style={window.innerWidth < 480 ? { lineHeight: "0.7rem" } : {}}
        >
          #
          {details.exam === "IELTS" ? details.transactionId : details.enquiryId}
        </p>
        <div className="text-left text-black">
          <p
            className="text-black"
            style={window.innerWidth < 480 ? { lineHeight: "1rem" } : {}}
          >
            {t("receipt.info")}
          </p>
          {window.innerWidth < 480 ? null : <br />}
          <p
            className="text-black"
            style={window.innerWidth < 480 ? { lineHeight: "1rem" } : {}}
          >
            <strong>{t("receipt.name")}</strong>: {details.firstName}{" "}
            {details.lastName}
            <br />
            <strong>{t("receipt.idNo")}</strong>: {details.candidatePassport}
            <br />
            <strong>{t("receipt.paymentDate")}</strong>:{" "}
            {moment(details.createdDate || details.createdAt).format(
              "DD/MM/YYYY",
            )}
            <br />
            <strong>{t("receipt.paymentAmount")}</strong>:{" "}
            {currencyFormatter(details.amount, details.currency || "UZS")}
            <br />
            <strong>{t("receipt.exam")}</strong>: {details.exam}
            <br />
            <strong>{t("receipt.module")}</strong>: {details.module}
            <br />
            {details.exam !== "Olympiad" && details.examDate && (
              <>
                <strong>{t("examDate")}</strong>:{" "}
                {String(details.examDate).includes("-")
                  ? moment(details.examDate).format("DD/MM/YYYY")
                  : details.examDate}
                <br />
              </>
            )}
          </p>
        </div>
        {/* Render the QR code */}
        <QRCodeSVG
          value={`https://payment.edu-action.uk/verification/${details.transactionId}`}
          size={128}
          bgColor={"#ffffff"}
          fgColor={"#ff6c1c"}
          level={"L"}
          includeMargin={true}
        />
        {/* <br /> */}
        <p style={window.innerWidth < 480 ? { lineHeight: "0.7rem" } : {}}>
          {t("receipt.qrInfo")}
        </p>
        <p style={{ fontSize: "10px", lineHeight: "0.8rem" }}>
          OOO “Edu Action” <br />
          Email: tkt@edu-action.uz, Website: edu-action.uk <br />
          Tel: +998 71 2300103 <br />
          {t("address1")}
        </p>
      </div>
    </div>
  );
}

export default Verification;
